/* eslint-disable */
import { Fragment, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../app/store';
import { classNames } from '../../../utils/classNames';
import TypingMessage from '../../../components/shared/typing-message/TypingMessage';
import { rome as moment, toNaiveISO } from '../../../utils/date';
// import ReactMarkdown from 'react-markdown';
import MessageActions from '../../../components/message-actions/MessageActions';
// import remarkGfm from 'remark-gfm';
// import rehypeHighlight from 'rehype-highlight';
import { useAppDispatch } from '../../../app/hooks';
import { useChatboxMutation, useGetTopicChatsMutation } from '../../../store/chatbox/chatboxApi';
import { resetFinishedFeedback, setChatMessages } from '../../../store/slices/chats.slice';
import { NavLink, useParams, useSearchParams } from 'react-router-dom';
import { useGetCurrentUserQuery } from '../../../store/user/userApi';
import AnimatedDiv from '../../../components/shared/animated-div/AnimatedDiv';
import { convertMarkdownToHTML } from '../../../utils/convertMarkdownToHTML';
import S3ExcelPreview from '../../../components/shared/s3-preview/S3ExcelPreview';
import S3PdfPreview from '../../../components/shared/s3-preview/S3PdfPreview';
import { cleanBrTagsAdvanced } from '../../../utils/clearNrTags';
import Resend from './Resend';
import { getStoredRequests } from '../../../utils/uniqueObjectToLocalstorage';
// import ReactMarkdown from 'react-markdown';
// import remarkGfm from 'remark-gfm';
// import rehypeHighlight from 'rehype-highlight';

const ChatContent = ({
	isFromHomepage,
	intro
}: {
	isFromHomepage?: boolean,
	intro?: boolean
}) => {
	const [searchParams] = useSearchParams();
	const { data: userInfo } = useGetCurrentUserQuery();
	const [chatTopicChat, { isLoading }] = useGetTopicChatsMutation()
	const dispatch = useAppDispatch();
	const chatEndRef = useRef<HTMLDivElement>(null);
	const audioRef = useRef<HTMLAudioElement | { pause: () => void; paused: boolean; currentTime: number } | null>(null);
	const { topicId, finishedFeedback } = useSelector(
		(state: RootState) => state.chats
	);
	const [chatBoxAdd] = useChatboxMutation()
	
	const {id} = useParams();

	const getChats = async () => {
		dispatch(setChatMessages([]))
		try {
			const { data } = await chatTopicChat(searchParams.get('topicId') || topicId).unwrap();
			dispatch(setChatMessages(data.elements));
			const getFailedItems = getStoredRequests('resend')
			dispatch(setChatMessages([...data.elements, ...(getFailedItems.filter(failed => failed.topic === searchParams.get('topicId')).map(item => ({...item, type: 'error'})))]));
			scrollToBottom()
		} catch (e) {
			console.log({e})
		}
	}

	const handleInitReportingChat = async () => {
		const tripId = id || '';
		const action = searchParams.get('type') || '';
		const feedbackId = searchParams.get('feedbackId') || '';
		await chatBoxAdd({
			tripId,
			action,
			feedbackId,
			message: '',
		}).unwrap();
	};

	useEffect(()=>{
		if (searchParams.get('type') === 'report-reminder') {
			dispatch(setChatMessages([]))
			handleInitReportingChat();
		}
	},[])

	const scrollToBottom = () => setTimeout(() => {
		const container = chatEndRef.current;
		if (!container) return;
		container.scrollIntoView({ behavior: 'smooth' });
	}, 500)

	useEffect(()=>{
		if (searchParams.get('topicId')){
			getChats();
		} else {
			dispatch(resetFinishedFeedback());
			if (!isFromHomepage && searchParams.get('type') !== 'report-reminder')
				dispatch(setChatMessages([]))
		}
	},[searchParams.get('topicId')])

	useEffect(()=>{
		if (searchParams.get('message')) {
			dispatch(
				setChatMessages([
					{
						_id: `${searchParams.get('message')}-${Math.random()}`,
						message: searchParams.get('message'),
						requestId: `${searchParams.get('message')}-${Math.random()}`,
						type: 'success',
						msgType: 'message',
					updatedAt: toNaiveISO(),
					createdAt: toNaiveISO(),
					userId: '',
					topic: '',
					agent: {
						name: 'my name'
					}
					},
				]),
			);
		}
		
	}, [searchParams.get('message')])

	const { messages } = useSelector(
		(state: RootState) => state.chats
	);

	useEffect(() => {
		if (!intro) scrollToBottom()
	}, []);

	const lastUserMessageHeight = document.querySelectorAll('.user-section')[document.querySelectorAll('.user-section').length - 1]?.clientHeight || 0

	console.log({messages})

	return (
		<div className={classNames('h-[80vh] md:h-[calc(100vh-270px)] w-full overflow-auto bg-gray-50 flex flex-col dark:text-primary-darkMode dark:bg-black mb-5 rounded-xl  xl:w-[760px] mx-auto', messages.length === 0 ? 'p-0' : 'p-5 border-2 border-gray-200')}>
			{isLoading && <div className='w-full h-full flex justify-center items-center'>
				<div className='flex items-center gap-1 typing'><span /><span /><span /></div>
			</div>}
			{(messages.length === 0 && !isLoading) &&
				<div className='flex flex-wrap w-full h-full items-center justify-center'>
					<div className="relative w-full h-full rounded-xl overflow-hidden z-0 flex flex-col">
						<img src="/images/orient-express.webp" alt="orient-express" className="absolute w-full h-full object-cover top-0 left-0 p-0 -z-10" />
						<div className="absolute w-full h-full object-cover top-0 left-0 p-0 -z-10 bg-white dark:bg-black bg-opacity-80 dark:bg-opacity-90" />
						<div className='m-auto'>
							<img src={userInfo?.data.logoUrl || "/svg/logo.svg"} className={classNames('m-auto w-80', userInfo?.data.logoUrl ? 'rounded-full' : '')} alt="hotel" />
							<p className='font-normal text-base text-gray-800 dark:text-white mt-5 text-center'>Ask questions. Let the magic happen</p>
						</div>
					</div>
				</div>
			}
			{messages.map(
				(conversation, index: number) => (
					<Fragment key={conversation?._id}>
						<div className='my-2 flex flex-col'>
							{conversation.agent ?
								<div 
									className='w-full flex flex-row'
									style={{minHeight: (messages.length - 1 === index && conversation.requestId && messages.length > 2) ? `calc(100vh - ${320 + lastUserMessageHeight}px)` : ''}}
									>
									<div className='pt-4'>
										<img alt='avatar' width={34} height={34} className='rounded-full mr-2' src={conversation.agent.imageUrl || '/svg/auth/rebecca.svg'} />
									</div>
									<div className='max-w-[90%] rounded-2xl p-4'>
										<div>
											{conversation.files && conversation.files.map(file => <div key={file.name} className='w-20 h-20 bg-gray-100 border border-gray-200 m-2 relative'>
												<img src={file.url} className='w-full h-full object-cover' alt={file.name} />
											</div>)}
										</div>
										{(conversation.message?.length && (messages.length - 1 === index && conversation.instantReply)) ?
											// {(conversation.message.length &&  (messages.length - 1 === index)) ?
											// {conversation.message ?
											<TypingMessage 
												key={conversation._id || conversation.requestId} 
												chatId={conversation._id || conversation.topic} 
												scrollToBottom={scrollToBottom} 
												message={cleanBrTagsAdvanced(conversation.message)} 
												updatedAt={conversation.updatedAt} 
												typingSpeed={500}
												audioRef={audioRef}
											/>
											: <AnimatedDiv>
												<>
													<div
														className="whitespace-pre-wrap break-words dark:text-primary-darkMode"
														dangerouslySetInnerHTML={{ __html: conversation?.message ? convertMarkdownToHTML(cleanBrTagsAdvanced(conversation?.message)) : '' }}
													/>
													{!!(conversation._id && conversation.message.length) &&
														<MessageActions
															chatId={conversation._id}
															message={conversation.message}
															liked={conversation.liked}
															disliked={conversation.disliked}
															favorite={conversation.favorite}
															updatedAt={conversation.updatedAt}
															audioRef={audioRef}

														/>}
												</>
											</AnimatedDiv>
										}
										{conversation.type === 'pending' && <div className='flex items-center gap-1 typing pt-3'><span /><span /><span /></div>}
									</div>
								</div>
								:
								<>
									<div className='flex flex-wrap ml-auto -mr-2'>
										{conversation.files && [...conversation.files].map(file => 
										<div key={file.name} className='w-60 max-h-48 bg-gray-100 border border-gray-200 m-2 relative'>
											{(file.name.includes('.pdf')) ?
											<>
												<S3PdfPreview pdfUrl={file.url} />
											</> :
											file.name.includes('.xlsx') ? <>
												<S3ExcelPreview s3Url={file.url} />
											</> :
											<img src={file.url} className='w-full h-full object-cover' alt={file.name} />
											}
										</div>)
										}
									</div>
									{conversation.message && <div className={classNames('bg-gray-200 dark:bg-bgColor-darkMode max-w-[90%] text-gray-900 dark:text-primary-darkMode rounded-2xl p-4 ml-auto user-section relative',
										//  conversation.type === 'pending' ? 'opacity-50': '',
										conversation.type === 'error' ? 'border-2 border-red-500 opacity-60' : ''
									)}
									>
										{conversation.type === 'error' && <Resend
											requestId={conversation.requestId || ''}
											topic={topicId || searchParams.get('topicId') || ''}
											tripId={id || ''}
											message={conversation.message}
										/>}
										<AnimatedDiv>
											<>
												<div className='w-full'>{conversation.message}</div>
												{!!conversation.updatedAt && <p className='text-gray-400 dark:text-primary-darkMode text-[10px] font-semibold text-right'>{moment(conversation.updatedAt).format('h:mm A')}</p>}
											</>
										</AnimatedDiv>
									</div>}
								</>
							}
						</div>
					</Fragment>
				)
			)}
			<div id='chatEnd' ref={chatEndRef} />
			{finishedFeedback && (
				<div className="m-3">
					<NavLink
						to='/home'
						className={`w-full py-3 rounded-full text-white text-center block 
							${isLoading ? 'bg-primary-default/50 cursor-not-allowed' : 'bg-primary-default hover:bg-primary-default/80'}
							transition duration-200`}
					>
						Go to Home Screen
					</NavLink>
				</div>
     	 )}
		</div>
	)
}

export default ChatContent;